// src/styles/ReviewsStyles.js
import styled from 'styled-components';
import { Card, StyledButton } from '../main/CommonStyles'; // Załóżmy, że Card i StyledButton są w CommonStyles

export const ReviewsPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.lg};
`;

export const FiltersWrapper = styled(Card)`
    padding: ${({ theme }) => theme.spacing.md};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    background-color: ${({ theme }) => theme.colors.white};

    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing.md};
    align-items: center;

    select, input {
        padding: ${({ theme }) => theme.spacing.sm};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        border-radius: ${({ theme }) => theme.borderRadius};
        font-family: ${({ theme }) => theme.fonts.main};
        font-size: 0.875rem;
        min-width: 150px;
    }
`;

export const PsychologistCard = styled(Card)`
    display: flex;
    gap: ${({ theme }) => theme.spacing.lg};
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const PsychologistAvatar = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid ${({ theme }) => theme.colors.primaryLightest};
    box-shadow: ${({ theme }) => theme.shadows.sm};

    @media (max-width: 768px) {
        width: 80px;
        height: 80px;
        align-self: center;
    }
`;

export const PsychologistInfo = styled.div`
    flex-grow: 1;
    h3 {
        font-size: 1.375rem; // między text-xl a text-2xl
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
        margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
    .specialties {
        margin-bottom: ${({ theme }) => theme.spacing.sm};
    }
    .location {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.colors.textMedium};
        margin-bottom: ${({ theme }) => theme.spacing.md};
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.spacing.xs};
    }
`;

export const PsychologistActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
    align-items: flex-start; // Przyciski wyrównane do lewej w kolumnie

     @media (min-width: 769px) {
        min-width: 180px; // Zapewnia miejsce na przyciski obok informacji
        align-items: flex-end; // Przyciski wyrównane do prawej, jeśli obok
    }
`;

export const ViewProfileButton = styled(StyledButton)`
    width: 100%;
`;

export const BookAppointmentButtonReview = styled(StyledButton)`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.secondary};
    &:hover {
        background-color: ${({ theme }) => theme.colors.secondaryDark};
    }
`;

export const ReviewSection = styled.div`
    margin-top: ${({ theme }) => theme.spacing.md};
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    padding-top: ${({ theme }) => theme.spacing.md};

    h4 {
        font-size: 1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
        margin-bottom: ${({ theme }) => theme.spacing.sm};
    }
`;

export const SingleReview = styled.div`
    background-color: ${({ theme }) => theme.colors.primaryLightest + '80'};
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
    border-radius: ${({ theme }) => theme.borderRadius};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    font-size: 0.875rem;
    .review-author {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
    }
    .review-text {
        color: ${({ theme }) => theme.colors.textMedium};
    }
`;